import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import "@/assets/css/main.css";

Vue.filter('snippet', function(value) {
    if (value !== null && value.length > 20) {
        return value.slice(0, 20) + " ...";
    } else {
        return value;
    }
});

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')